<div class="notification__image-wrapper">
  <pp-icon class="notification__image" [ppSrc]="EIconPath.NOTIFICATION_ICON_LOCATION" ppColor="primary-950"></pp-icon>
</div>

<span class="notification__blue-text">{{ 'changed' | ppTranslate }}</span>
{{ 'the' | ppTranslate }}
<span class="notification__bold">{{ 'location' | ppTranslate }}</span>
{{ 'of_a_point_you' | ppTranslate }}
{{ notificationReason }}.
